/**
 * EXAMPLE CONTENT — what each code of the template's example record means. A
 * project replaces this with its own codes; a code that arrives from another
 * system is described here with how sure the meaning is and the evidence for
 * it (docs/DATA-MODEL.md → "Codes").
 *
 * The short names are the app's own (`statusLabels`), so the dictionary and
 * the status pill can never disagree.
 */
import { type ItemStatus, itemStatuses, statusLabels } from '@/core/items'
import type { CodeDef } from '../types.ts'
import { majikCodeDefs } from './majik-codes.ts'

const ITEM_STATUS_MEANING: Record<ItemStatus, string> = {
  todo: 'Not started yet. New items start here unless someone picks another status.',
  in_progress: 'Someone is working on it.',
  done: 'Finished. Still on the Projects list until it is archived.',
  archived: 'Put away: kept as part of the record, but no longer on the Projects list.',
}

export const itemCodeDefs: readonly CodeDef[] = itemStatuses.map((value) => ({
  entity: 'item',
  field: 'status',
  value,
  label: statusLabels[value],
  meaning: ITEM_STATUS_MEANING[value],
  confidence: 'confirmed',
  evidence: 'Declared in the app’s own code (src/core/items/item.ts).',
}))

/** Every code the app describes: the example's and Majik's (majik-codes.ts). */
export const codeDefs: readonly CodeDef[] = [...itemCodeDefs, ...majikCodeDefs]
